import { featureFlagService } from "../services/featureFlagService";
import { useAsyncData } from "./useAsyncData";

export function useFeatureFlags() {
  return useAsyncData(
    async () => {
      const [flags, packageDefaults, userOverrides] = await Promise.all([
        featureFlagService.listFlags(),
        featureFlagService.listPackageDefaults(),
        featureFlagService.listUserOverrides(),
      ]);

      return { flags, packageDefaults, userOverrides };
    },
    [],
  );
}
